import React from 'react';

import App from './App';

import { BrowserRouter } from 'react-router-dom'
import ReactDOM from 'react-dom/client';

import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './SSOAuth/authConfig';

import { ConfigProvider } from 'antd';
import esES from 'antd/lib/locale/es_ES'
import { defaultTheme } from "./config/AppConfig";

import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './Redux/app/store';
import "./assets/css/style.css";

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().then(() => {
  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
    }
  });
  
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter basename={process.env.REACT_APP_BASE_NAME || "/"}>
        <MsalProvider instance={msalInstance}  >
          <PersistGate loading={null} persistor={persistor}>
            <ConfigProvider locale={esES} theme={defaultTheme} >
              <Provider store={store}> 
                <App/> 
              </Provider>
            </ConfigProvider>
          </PersistGate>
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
});
